import React, { useContext, useState, useEffect } from 'react'

import styles from './Adicionales.module.css'
import Subtitle from '../Subtitle'
import GeneralContext from '../../context/GeneralContext'

import * as Globales from '../../utils/globales'
import * as Funciones from '../../utils/funciones'
import DetallePreguntaAdicional from '../DetallePreguntaAdicional'
import * as GeneralActions from "../../store/actions/generalActions";
import Endoso from '../Endoso/Endoso'
import DetalleDeclaracionJuradaAdicional from '../DetalleDeclaracionJuradaAdicional'
import ListaDetallePreguntaReemplazoAdicional from '../ListaDetallePreguntaReemplazoAdicional'

const AdicionalesAseguradoAdicional = ({ state, setState, paginaActual, listaSolicitudes, product }) => {
    
    const initialState = {
        preguntasAdicional: []
    }
    
    const [localStateAdicional, setLocalStateAdicional] = useState(initialState)
    const [questionsAdicional, setQuestionsAdicional] = useState([]);
    const { state: generalState, dispatch: generalDispatch } = useContext(GeneralContext)
    
    let user = generalState.users.filter(userAux => userAux.isAuthenticated)[0]
    let prospecto = user.listaProspectos.filter(prospectoAux => prospectoAux.isSelected)[0]
    let cotizacion = prospecto.cotizaciones.filter(cotizacionAux => cotizacionAux.isSelected || cotizacionAux.completado)[0]
    
    const obtenerMostrarDetalle = (pregunta) => {
        if (pregunta.tipoDetalle === 1) {
            return pregunta.respuestaRapida === 1
        } else if (pregunta.tipoDetalle === 2) {
            if (pregunta.respuestaRapida === 1) {
                return (cotizacion.esAPFamiliar
                    && (state.aseguradoAdicional.estadoCivil.codigo === 1 || state.aseguradoAdicional.estadoCivil.codigo === 2
                        || state.aseguradoAdicional.estadoCivil.codigo === 3 || state.aseguradoAdicional.estadoCivil.codigo === 5))
            } else {
                return false
            }
        }
    }
    
    const hasCodigoLineaNegocioAP= product?.some(item => item.codigoLineaNegocio === 50);
    // Los codigoProducto 176 y 177 deben desabilitar la pregunta 5
    const hasCodigoProductoDisabled = product?.some(item => item.codigoProducto === "176" || item.codigoProducto === "177" );

    useEffect(() => {
        if (hasCodigoLineaNegocioAP) {
            if(hasCodigoProductoDisabled){
                setQuestionsAdicional(localStateAdicional?.preguntasAdicional.filter((pregunta) => pregunta.idBancoPregunta !== 115));
            } else {
                setQuestionsAdicional(localStateAdicional.preguntasAdicional);
            }
        } else {
            setQuestionsAdicional(localStateAdicional.preguntasAdicional);
        }
    }, [hasCodigoLineaNegocioAP, localStateAdicional.preguntasAdicional, hasCodigoProductoDisabled]);

    const hasQuestionsResidencial = localStateAdicional?.preguntasAdicional?.some(pregunta => pregunta.idBancoPregunta === 14 || pregunta.idBancoPregunta === 52);

    useEffect(() => {
        if (hasQuestionsResidencial && !cotizacion.flagDeclaJurada) {
            setQuestionsAdicional(localStateAdicional?.preguntasAdicional.filter((pregunta) => pregunta.idBancoPregunta !== 14 &&  pregunta.idBancoPregunta !== 52));
        } else {
            setQuestionsAdicional(localStateAdicional?.preguntasAdicional);
        }

        }, [localStateAdicional.preguntasAdicional, hasQuestionsResidencial]);

    useEffect(() => {
        const obtenerRespuestaRapida = (pregunta) => {
            if (pregunta.respuestaRapida === null || pregunta.respuestaRapida === undefined || pregunta.respuestaRapida === -1) {
                if (pregunta.tipoDetalle === 1) {
                    let respuesta = state.aseguradoAdicional.respuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                    if (respuesta !== undefined && respuesta !== null) {
                        return respuesta.respuesta
                    } else {
                        return -1
                    }
                } else if (pregunta.tipoDetalle === 2) {
                    let respuestaAsegurado = state.aseguradoAdicional.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                    let respuestaConyuge = state.conyuge !== undefined && state.conyuge !== null
                        && state.conyuge.respuestas !== undefined
                        ? (state.conyuge && state.conyuge.respuestas) && state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta === pregunta.idBancoPregunta
                            && (respuesta.respuesta === 1 || respuesta.respuesta === 0))[0]
                        : null
                    
                    if (respuestaAsegurado !== undefined && respuestaAsegurado !== null) {
                        return respuestaAsegurado.respuesta
                    } else if (respuestaConyuge !== undefined && respuestaConyuge !== null) {
                        return respuestaConyuge.respuesta
                    } else {
                        return -1
                    }
                } else if (pregunta.tipoDetalle === 3) {
                    let respuesta = state.aseguradoAdicional.respuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                    if (respuesta !== undefined && respuesta !== null) {
                        return respuesta.respuesta
                    } else {
                        return -1
                    }
                } else if (pregunta.tipoDetalle === null) {
                    if (cotizacion.flagDeclaJurada) {
                        if (paginaActual === 'aseguradoAdicional') {
                            let respuesta = state.aseguradoAdicional.respuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                                && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                            if (respuesta !== undefined && respuesta !== null) {
                                return respuesta.respuesta
                            } else {
                                return -1
                            }
                        } else if (paginaActual === 'contratante') {
                            let respuesta = state.contratante !== null && state.contratante.respuestas !== undefined
                                ? state.contratante.respuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                                    && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                                : null
                            if (respuesta !== undefined && respuesta !== null) {
                                return respuesta.respuesta
                            } else {
                                return -1
                            }
                        }
                    } else {
                        let respuestaEncontrada = false
                        let respuestasAsegurado = state[paginaActual].respuestas.map(respuesta => {
                            if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                                respuesta.respuesta = 0
                                respuestaEncontrada = true
                            }
                            return respuesta
                        })

                        if (!respuestaEncontrada) {
                            if (respuestasAsegurado.length > 0) {
                                respuestasAsegurado.push({
                                    idBancoPregunta: pregunta.idBancoPregunta,
                                    respuesta: 0
                                })
                            } else {
                                respuestasAsegurado = [{
                                    idBancoPregunta: pregunta.idBancoPregunta,
                                    respuesta: 0
                                }]
                            }
                        }
                        setState((state) => {
                            return {
                                ...state,
                                [paginaActual]: {
                                    ...state[paginaActual],
                                    respuestas: respuestasAsegurado
                                }
                            }
                        })
                        return 0
                    }
                } else if (pregunta.tipoDetalle === 5) {
                    let respuesta = state.aseguradoAdicional.respuestas.filter(respuestaAux => respuestaAux.idBancoPregunta === pregunta.idBancoPregunta
                        && (respuestaAux.respuesta === 1 || respuestaAux.respuesta === 0))[0]
                    if (respuesta !== undefined && respuesta !== null) {
                        return respuesta.respuesta
                    } else {
                        return -1
                    }
                }
            } else {
                if (paginaActual === 'contratante') {
                    if (state.contratante.respuestas !== undefined && state.contratante.respuestas !== null) {
                        return pregunta.respuestaRapida
                    } else {
                        return -1
                    }
                } else {
                    return pregunta.respuestaRapida
                }
            }
        }

        const obtenerApFamiliar = () => {
            return (cotizacion.esAPFamiliar && state.aseguradoAdicional !== undefined
                && (state.aseguradoAdicional.estadoCivil.codigo === 1 || state.aseguradoAdicional.estadoCivil.codigo === 2
                    || state.aseguradoAdicional.estadoCivil.codigo === 3 || state.aseguradoAdicional.estadoCivil.codigo === 5))
        }

        const cargarPreguntas = () => {
            //Armando Preguntas Iniciales
            let grupoPregunta = null
            if (cotizacion.esDistintoAsegurado) {
                if (paginaActual === 'aseguradoAdicional') {
                    grupoPregunta = 1
                } else if (paginaActual === 'contratante') {
                    grupoPregunta = 2
                }
            } else {
                grupoPregunta = 0
            }

            let preguntasAdicional = []
            const actuPreguntas = cotizacion.preguntasAdicional.map((pregunta) => {
                let retorna = false
                let tipoDetalle = null
                Globales.PREGUNTAS_INICIALES_ADICIONAL.map(preguntaGlobal => {
                    if (preguntaGlobal.codigo === pregunta.idBancoPregunta
                        && (preguntaGlobal.grupo === grupoPregunta || grupoPregunta === 0)) {
                        retorna = true
                        tipoDetalle = preguntaGlobal.tipoDetalle
                    }
                    return preguntaGlobal
                })

                if (retorna) {
                    //Armando Respuestas
                    if (state.aseguradoAdicional !== null && state.aseguradoAdicional !== undefined) {
                        pregunta.tipoDetalle = tipoDetalle
                        pregunta.respuestaRapida = obtenerRespuestaRapida(pregunta)
                        pregunta.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                        pregunta.listaAsegurados = obtenerListaAsegurados(pregunta)
                        pregunta.apFamiliar = obtenerApFamiliar()
                    } else if (state.contratante !== null && state.contratante !== undefined) {
                        pregunta.tipoDetalle = tipoDetalle
                        pregunta.respuestaRapida = obtenerRespuestaRapida(pregunta)
                    }
                    preguntasAdicional.push(pregunta)
                }
                return pregunta
            })

            generalDispatch(GeneralActions.updateAseguradoAdicionalProspecto(actuPreguntas, null))

            if (localStateAdicional.preguntasAdicional.length === 0) {
                setLocalStateAdicional((localStateAux) => {
                    return {
                        ...localStateAux,
                        preguntasAdicional: preguntasAdicional
                    }
                })
            }
            
            setState((stateAux) => {
                return {
                    ...stateAux,
                    preguntasAdicional: preguntasAdicional
                }
            })
        }

        cargarPreguntas()
    }, [state.aseguradoAdicional && state.aseguradoAdicional.respuestas, state.conyuge, state.contratante && state.contratante.respuestas])

    const obtenerListaAsegurados = (pregunta) => {
        let listaAsegurados = []
        if (pregunta.tipoDetalle === 2) {
            if (pregunta.respuestaRapida === 1) {
                if (cotizacion.esAPFamiliar) {
                    if (state.aseguradoAdicional.estadoCivil.codigo === 1 || state.aseguradoAdicional.estadoCivil.codigo === 2) {
                        listaAsegurados.push({
                            codigoAsegurado: 1,
                            parentesco: 'Titular',
                            nombre: Funciones.mostrarCamelCase(state.aseguradoAdicional.nombres + ' ' + state.aseguradoAdicional.apellidoPaterno + ' '
                                + state.aseguradoAdicional.apellidoMaterno)
                        })
                        listaAsegurados.push({
                            codigoAsegurado: 2,
                            parentesco: 'Cónyuge',
                            nombre: state.conyuge ? Funciones.mostrarCamelCase(state.conyuge.nombres + ' ' + state.conyuge.apellidoPaterno + ' '
                                + state.conyuge.apellidoMaterno) : ''
                        })
                    } else if (state.aseguradoAdicional.estadoCivil.codigo === 3 || state.aseguradoAdicional.estadoCivil.codigo === 5) {
                        listaAsegurados.push({
                            codigoAsegurado: 1,
                            parentesco: 'Titular',
                            nombre: Funciones.mostrarCamelCase(state.aseguradoAdicional.nombres + ' ' + state.aseguradoAdicional.apellidoPaterno + ' '
                                + state.aseguradoAdicional.apellidoMaterno)
                        })
                    }
                }
            }
        }
        return listaAsegurados
    }

    const handleChangeRespuesta = (pregunta, valorRespuesta) => {
        const cambiarRespuestaTipoUno = () => {
            //Campo de Pregunta Local
            let preguntasAdicional = localStateAdicional.preguntasAdicional.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                    preguntaAux.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                }
                return preguntaAux
            })
            setLocalStateAdicional((localStateAux) => {
                return {
                    ...localStateAux,
                    preguntasAdicional: preguntasAdicional
                }
            })

            //Cambio de Pregunta Asegurado
            let respuestaEncontrada = false
            let respuestasAsegurado = state.aseguradoAdicional.respuestas.map(respuesta => {
                if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                    respuesta.respuesta = valorRespuesta
                    respuestaEncontrada = true
                }
                return respuesta
            })

            if (!respuestaEncontrada) {
                if (respuestasAsegurado.length > 0) {
                    respuestasAsegurado.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAsegurado = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            //Otros Seguros
            let otrosSeguros = state.aseguradoAdicional.otrosSeguros
            if (valorRespuesta === 0) {
                otrosSeguros = []
            }

            setState((stateAux) => {
                return {
                    ...stateAux,
                    aseguradoAdicional: {
                        ...stateAux.aseguradoAdicional,
                        respuestas: respuestasAsegurado,
                        otrosSeguros: otrosSeguros
                    }
                }
            })
        }
        // se mapea las preguntas para cambiar la respuesta de la pregunta seleccionada
        const cambiarRespuestaTipoDos = () => {
            //Campo de Pregunta Local
            let preguntasAdicional = localStateAdicional.preguntasAdicional.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                    preguntaAux.mostrarDetalle = obtenerMostrarDetalle(pregunta)
                    preguntaAux.listaAsegurados = obtenerListaAsegurados(pregunta)
                }
                return preguntaAux
            })

            setLocalStateAdicional((localStateAdicional) => {
                return {
                    ...localStateAdicional,
                    preguntasAdicional: preguntasAdicional
                }
            })

            if (pregunta.mostrarDetalle) {
                if (valorRespuesta === 1) {
                    //Abre Detalle
                    //Combo -Seleccione-
                    //Eliminar Respuesta Asegurado/Conyuge
                    let respuestasAsegurado = null
                    if (state.aseguradoAdicional !== null && state.aseguradoAdicional !== undefined) {
                        respuestasAsegurado = state.aseguradoAdicional.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                    }

                    let respuestasConyuge = null
                    if (state.conyuge !== null && state.conyuge !== undefined) {
                        respuestasConyuge = state.conyuge.respuestas && state.conyuge.respuestas.filter(respuesta => respuesta.idBancoPregunta !== pregunta.idBancoPregunta)
                    }

                    setState((state) => {
                        return {
                            ...state,
                            aseguradoAdicional: {
                                ...state.aseguradoAdicional,
                                respuestas: respuestasAsegurado
                            },
                            conyuge: {
                                ...state.conyuge,
                                respuestas: respuestasConyuge
                            }
                        }
                    })
                } else if (valorRespuesta === 0) {
                    //Nunca se dara
                }
            } else {
                //Agregar Respuesta Asegurado/Conyuge
                //Asegurado
                let respuestaEncontrada = false
                let respuestasAsegurado = state.aseguradoAdicional.respuestas.map(respuesta => {
                    if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                        respuesta.respuesta = valorRespuesta
                        respuestaEncontrada = true
                    }
                    return respuesta
                })

                if (!respuestaEncontrada) {
                    if (respuestasAsegurado.length > 0) {
                        respuestasAsegurado.push({
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        })
                    } else {
                        respuestasAsegurado = [{
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        }]
                    }
                }

                //Conyuge
                let respuestasConyuge = []
                if (state.conyuge !== null && state.conyuge !== undefined) {
                    let respuestaEncontradaConyuge = false
                    respuestasConyuge = state.conyuge.respuestas && state.conyuge.respuestas.map(respuesta => {
                        if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                            respuesta.respuesta = valorRespuesta
                            respuestaEncontradaConyuge = true
                        }
                        return respuesta
                    })

                    if (!respuestaEncontradaConyuge) {
                        if (respuestasConyuge === undefined) {
                            respuestasConyuge = []
                        }
                        respuestasConyuge.push({
                            idBancoPregunta: pregunta.idBancoPregunta,
                            respuesta: valorRespuesta
                        })
                    }
                }
                setState((state) => {
                    return {
                        ...state,
                        aseguradoAdicional: {
                            ...state.aseguradoAdicional,
                            respuestas: respuestasAsegurado
                        },
                        conyuge: {
                            ...state.conyuge,
                            respuestas: respuestasConyuge
                        }
                    }
                })
            }
        }

        const cambiarRespuestaTipoTres = () => {
            if (valorRespuesta === 0 && cotizacion.listaDetalleReemplazo !== undefined) {
                generalDispatch(GeneralActions.cleanAseguradoFieldAdicional(undefined, true))
            } else if (valorRespuesta === 1) {
                generalDispatch(GeneralActions.updateRespuestaRapida(1))
            }

            let preguntasAdicional = localStateAdicional.preguntasAdicional.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                }
                return preguntaAux
            })

            setLocalStateAdicional((localStateAdicional) => {
                return {
                    ...localStateAdicional,
                    preguntasAdicional: preguntasAdicional
                }
            })

            let respuestaEncontrada = false
            let respuestasAux = state.aseguradoAdicional.respuestas.map(respuesta => {
                if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                    respuesta.respuesta = valorRespuesta
                    respuestaEncontrada = true
                }
                return respuesta
            })

            if (!respuestaEncontrada) {
                if (respuestasAux.length > 0) {
                    respuestasAux.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAux = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            setState((state) => {
                return {
                    ...state,
                    aseguradoAdicional: {
                        ...state.aseguradoAdicional,
                        respuestas: respuestasAux
                    }
                }
            }) 
        }

        const cambiarRespuestaTipoNull = () => {
            //Campo de Pregunta Local
            let preguntasAdicional = localStateAdicional.preguntasAdicional.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                }
                return preguntaAux
            })
            setLocalStateAdicional((localStateAdicional) => {
                return {
                    ...localStateAdicional,
                    preguntasAdicional: preguntasAdicional
                }
            })

            //Cambio de Pregunta Asegurado
            let respuestaEncontrada = false
            let respuestasAux = []
            if (state[paginaActual].respuestas !== undefined) {
                respuestasAux = state[paginaActual].respuestas.map(respuesta => {
                    if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                        respuesta.respuesta = valorRespuesta
                        respuestaEncontrada = true
                    }
                    return respuesta
                })
            }

            if (!respuestaEncontrada) {
                if (respuestasAux.length > 0) {
                    respuestasAux.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAux = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            setState((state) => {
                return {
                    ...state,
                    [paginaActual]: {
                        ...state[paginaActual],
                        respuestas: respuestasAux,
                        subRespuestas: valorRespuesta === 0 ? [] : state[paginaActual].subRespuestas
                    },
                    detalle1Adicional: valorRespuesta === 0 ? {NIT: null} : state.detalle1Adicional,
                    detalle2Adicional: valorRespuesta === 0 ? [
                        {
                            pais: null,
                            NIT: null
                        }
                    ] : state.detalle2Adicional,
                    noTieneNITAdicional: valorRespuesta === 0 ? 0 : state.noTieneNITAdicional,
                    noTieneNITDescAdicional: valorRespuesta === 0 ? null : state.noTieneNITDescAdicional,
                    subPreguntasAdicional: valorRespuesta === 0 ? [] : state.subPreguntasAdicional,
                    campoValidadoAdicional: {
                        ...state.campoValidadoAdicional,
                        NIT1: valorRespuesta === 0 ? true : state.campoValidadoAdicional.NIT1,
                        pais: valorRespuesta === 0 ? [] : state.campoValidadoAdicional.pais,
                        NIT: valorRespuesta === 0 ? [] : state.campoValidadoAdicional.NIT,
                        noTieneNIT: valorRespuesta === 0 ? true : state.campoValidadoAdicional.noTieneNIT,
                        noTieneNITDesc: valorRespuesta === 0 ? true : state.campoValidadoAdicional.noTieneNITDesc
                    }
                }
            })
        }

        const cambiarRespuestaTipoCinco = () => {
            //Campo de Pregunta Local
            let preguntasAdicional = localStateAdicional.preguntasAdicional.map(preguntaAux => {
                if (preguntaAux.idBancoPregunta === pregunta.idBancoPregunta) {
                    preguntaAux.respuestaRapida = valorRespuesta
                }
                return preguntaAux
            })
            setLocalStateAdicional((localStateAdicional) => {
                return {
                    ...localStateAdicional,
                    preguntasAdicional: preguntasAdicional
                }
            })

            //Cambio de Pregunta Asegurado
            let respuestaEncontrada = false
            let respuestasAux = []
            if (state[paginaActual].respuestas !== undefined) {
                respuestasAux = state[paginaActual].respuestas.map(respuesta => {
                    if (respuesta.idBancoPregunta === pregunta.idBancoPregunta) {
                        respuesta.respuesta = valorRespuesta
                        respuestaEncontrada = true
                    }
                    return respuesta
                })
            }

            if (!respuestaEncontrada) {
                if (respuestasAux.length > 0) {
                    respuestasAux.push({
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    })
                } else {
                    respuestasAux = [{
                        idBancoPregunta: pregunta.idBancoPregunta,
                        respuesta: valorRespuesta
                    }]
                }
            }

            setState((state) => {
                return {
                    ...state,
                    aseguradoAdicional: {
                        ...state.aseguradoAdicional,
                        respuestas: respuestasAux
                    },
                    credito: valorRespuesta === 0 ? null : state.credito,
                    entidad: valorRespuesta === 0 ? null : state.entidad,
                    campoValidadoAdicional: {
                        ...state.campoValidadoAdicional,
                        credito: valorRespuesta === 0 ? true : state.campoValidadoAdicional.credito,
                        entidad: valorRespuesta === 0 ? true : state.campoValidadoAdicional.entidad
                    }
                }
            })
        }

        if (pregunta.tipoDetalle === 1) {
            cambiarRespuestaTipoUno()
        } else if (pregunta.tipoDetalle === 2) {
            cambiarRespuestaTipoDos()
        } else if (pregunta.tipoDetalle === 3) {
            cambiarRespuestaTipoTres()
        } else if (pregunta.tipoDetalle === 5) {
            cambiarRespuestaTipoCinco()
        } else {
            cambiarRespuestaTipoNull()
        }
    }

    //Modo lectura
    let Deshabilitar = (complete) => {
        complete = cotizacion.edicionInhabilitada
        if (complete === true) {
            return true
        } else {
            return false
        }
    }

    return (
        <div className={styles['areadatosprospecto']}>
            <Subtitle sname='Adicional' />
            {questionsAdicional.map((pregunta, index) => {
                return (
                    (pregunta.idBancoPregunta === 14 || pregunta.idBancoPregunta === 52) && !cotizacion.flagDeclaJurada ?
                    null
                    :
                    <div key={index}
                        className={`${styles['adicionalPregunta']} ${index === 0 ? styles['top18'] : null}`}>
                        <div className={styles['grupodelist']}>
                            <div>{index + 1}.</div>
                            &nbsp;&nbsp;
                            <div className={styles['areaPregunta']}> {/*CMUNAYLLA: se agrega este estilo para alinear las preguntas*/}
                                {pregunta.descripcion}
                            </div>
                            <div className={styles['areaoptionon']}>
                                <form>
                                    <div className={styles["optionlight"]}>
                                        <label className={styles['label-radio']}>
                                            <input
                                                type="radio"
                                                name="lightAdicional"
                                                value="true"
                                                checked={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                    || pregunta.respuestaRapida === 1
                                                }
                                                selected={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 1)
                                                    || pregunta.respuestaRapida === 1
                                                }
                                                onChange={(e) => handleChangeRespuesta(pregunta, 1)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className={`span-radio-si-no ${styles['radio-label']}`}>Si</span>
                                        </label>
                                        <label className={styles['label-radio']}>
                                            <input
                                                type="radio"
                                                name="lightAdicional"
                                                value="false"
                                                checked={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                    || pregunta.respuestaRapida === 0
                                                }
                                                selected={(state.contratante && state.contratante.respuestas === undefined ? false : pregunta.respuestaRapida === 0)
                                                    || pregunta.respuestaRapida === 0
                                                }
                                                onChange={(e) => handleChangeRespuesta(pregunta, 0)}
                                                disabled={Deshabilitar() !== true ? false : true}
                                            />
                                            <span className={`span-radio-si-no ${styles['radio-label']}`}>No</span>
                                        </label>
                                    </div>
                                </form>
                            </div>
                        </div>
                        
                        {pregunta !== undefined && pregunta.mostrarDetalle && pregunta.respuestaRapida === 1
                            ? <div>
                                <DetallePreguntaAdicional
                                    state={state}
                                    setState={setState}
                                    tipo={pregunta.tipoDetalle}
                                    pregunta={pregunta} />
                            </div>
                            : null
                        }


                        {/* {pregunta !== undefined && (pregunta.idBancoPregunta === 3 || pregunta.idBancoPregunta === 44) && pregunta.respuestaRapida === 1 ? 
                            <ListaDetallePreguntaReemplazoAdicional 
                                listaSolicitudes={listaSolicitudes} 
                                state={state} 
                                setState={setState} 
                            />
                            : null
                        } */}

                        {pregunta !== undefined && (pregunta.idBancoPregunta === 14 || pregunta.idBancoPregunta === 52) && pregunta.respuestaRapida === 1 ?
                            <DetalleDeclaracionJuradaAdicional
                                state={state}
                                setState={setState}
                                paginaActual={paginaActual}
                            />
                            : null
                        }
                    </div>
                )
            })}
        </div>
    )
}

export default AdicionalesAseguradoAdicional